function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.414 7l5.293 5.293a1 1 0 01-1.414 1.414L7 8.414l-5.293 5.293a1 1 0 01-1.414-1.414L5.586 7 .293 1.707A1 1 0 011.707.293L7 5.586 12.293.293a1 1 0 011.414 1.414L8.414 7z",
  fill: "#EA1362"
});

var SvgNo = function SvgNo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTguNDE0IDdsNS4yOTMgNS4yOTNhMSAxIDAgMCAxLTEuNDE0IDEuNDE0TDcgOC40MTRsLTUuMjkzIDUuMjkzYTEgMSAwIDAgMS0xLjQxNC0xLjQxNEw1LjU4NiA3IC4yOTMgMS43MDdBMSAxIDAgMCAxIDEuNzA3LjI5M0w3IDUuNTg2IDEyLjI5My4yOTNhMSAxIDAgMCAxIDEuNDE0IDEuNDE0TDguNDE0IDd6IiBmaWxsPSIjRUExMzYyIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=";
export { SvgNo as ReactComponent };